<template>
  <div class="tableau-titre-wrapper d-flex">
    <div class="d-flex scroll-action" v-if="shouldScroll">
      <div @click="scrollLeft()" class="d-flex justify-content-between align-items-center"><font-awesome-icon :icon="['fas', 'chevron-left']" /></div>
      <div @click="scrollRight()" class="d-flex justify-content-between align-items-center"><font-awesome-icon :icon="['fas', 'chevron-right']" /></div>
    </div>
    <ul ref="onglet" class="onglet-list">
      <li
        v-for="tableauDetail in tableauDetails"
        :key="tableauDetail.id"
        class="d-flex justify-content-between align-items-center"
        :class="tableauDetail.id === parseInt(currentOnglet) ? 'active-tab' : ''"
        @click.prevent="handleClickOnglet(tableauDetail.id)"
      >
        <div
          class="title-cell"
          :contenteditable="isEditable[tableauDetail.id]"
          @blur.stop="handleBlur"
          @keydown.enter="handleEnter($event)"
          :ref="'input' + tableauDetail.id"
          :class="{'px-1': readOnly}"
        >
          {{ tableauDetail.nom }}
        </div>
        <span
          class="arrow"
          @click.prevent.stop="handleClick($event, tableauDetail)"
          v-if="!readOnly"
          ><font-awesome-icon :icon="['fas', 'angle-down']"
        /></span>
      </li>
    </ul>
    <div
      v-if="!readOnly"
      class="d-flex add-ctnr justify-content-between align-items-center"
    >
      <div v-if="!this.pending()" class="add-button" @click.prevent="createTableau">
        <font-awesome-icon :icon="['fas', 'plus']" />
      </div>
      <div v-else class="add-button">
        <b-spinner small type="grow"></b-spinner>
      </div>
    </div>
    <vue-simple-context-menu
      :elementId="'ongletContextualMenu'"
      :options="menuOptions || []"
      :ref="'vueSimpleContextMenu'"
      @option-clicked="optionClicked"
    >
    </vue-simple-context-menu>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    tableauDetails: {
      type: Array
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['currentOnglet']),
    menuOptions () {
      if (this.tableauDetails.length === 1) {
        return [{ name: 'Renommer' }]
      }
      if (this.tableauDetails.length > 1) {
        return [{ name: 'Supprimer' }, { name: 'Renommer' }]
      }
      if (!this.tableauDetails) {
        return []
      }
    },
    visibleWidth () {
      return this.documentWidth - (this.documentWidth / 3)
    }
  },
  mounted () {
    this.documentWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  },
  data () {
    return {
      isEditable: {},
      detailsOptionSelected: {},
      shouldScroll: false
    }
  },
  watch: {
    tableauDetails (val) {
      this.$nextTick().then(_ => {
        this.shouldScroll = this.tabListWidth() >= this.visibleWidth
      })
    }
  },
  methods: {
    ...mapGetters(['pending']),
    createTableau () {
      this.$emit('addOnglet')
    },
    // affichage contexte menu au click
    handleClick (event, item) {
      this.$refs.vueSimpleContextMenu.showMenu(event, item)
    },
    scrollLeft () {
      const currentScrollX = this.$refs['onglet'].scrollLeft
      const currentScrollY = this.$refs['onglet'].scrollTop
      this.$refs['onglet'].scrollTo(currentScrollX - 80, currentScrollY)
    },
    scrollRight () {
      const currentScrollX = this.$refs['onglet'].scrollLeft
      const currentScrollY = this.$refs['onglet'].scrollTop
      this.$refs['onglet'].scrollTo(currentScrollX + 80, currentScrollY)
    },
    tabListWidth () {
      if (this.$refs['onglet']) {
        return parseInt(this.$refs['onglet'].clientWidth)
      }
      return 0
    },
    optionClicked (event) {
      let menuName = event.option.name.toLowerCase()
      let id = event.item.id
      this.detailsOptionSelected = event.item

      if (menuName === 'renommer') {
        this.$set(this.isEditable, id, true)
        setTimeout(() => {
          this.$refs['input' + id][0].focus()
        })
      }

      this.$emit(menuName, id)
    },
    handleBlur (event) {
      this.isEditable = {}
      this.$emit('changeOngletTitre', event, this.detailsOptionSelected)
    },
    handleClickOnglet (id) {
      this.$emit('changeOnglet', id)
    },
    handleEnter (event) {
      event.target.blur()
      return false
    }
  }
}
</script>
<style lang="scss">
.tableau-titre-wrapper {
  .scroll-action {
    margin-bottom: 0;
    padding-left: 0;
    border-right: 1px solid #e5e5e5;
    -webkit-box-shadow: 10px 1px 7px -3px rgba(124, 124, 124, 0.4);
    -moz-box-shadow: 10px 1px 7px -3px rgba(124, 124, 124, 0.4);
    box-shadow: 10px 1px 7px -3px rgba(124, 124, 124, 0.4);
    div:first-child {
      border-right: 1px solid #e5e5e5;
    }
    div {
      border: 1px solid #2b3085;
      cursor: pointer;
      padding: 0 5px;
      color: #9395c1;
      &:hover {
        color: #2b3085;
      }
    }
  }
  margin-left: 50px;
  .add-ctnr {
    .add-button {
      cursor: pointer;
      margin-bottom: 0;
      background-color: #d2d3e5;
      height: 25px;
      line-height: 25px;
    }
  }
  ul.onglet-list {
    list-style: none;
    display: flex;
    margin-bottom: 0;
    padding-left: 0;
    max-width: calc(100vw - (100vw / 3));
    overflow: hidden;
    li {
      font-family: "Open Sans";
      font-weight: 600;
      font-size: 12px;
      text-align: center;
      border: 1px solid #2b3085;
      padding: 0 5px;
      cursor: default;
      .title-cell {
        padding-top: 2.5px;
        padding-bottom: 2.5px;
        text-transform: uppercase;
        white-space: nowrap;
        color: #2b3085;
      }
      .arrow {
        padding-left: 5px;
        cursor: pointer;
      }
      &.active-tab {
        box-shadow: 4px 0 15px 0 rgba(0, 0, 0, 0.1);
        background-color: #2b3085;
        color: #fff;
        .title-cell {
          color: #fff;
        }
      }
      .add-button {
        cursor: pointer;
        margin-bottom: 0;
        background-color: #d2d3e5;
        height: 25px;
        line-height: 25px;
      }
    }
  }
}
.vue-simple-context-menu {
  border-radius: 0;
  &--active {
  }

  &__item {
    font-family: "Open Sans";
    font-size: 14px;
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 5px;
    padding-bottom: 5px;
    &:hover {
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tableau/tableauTitre.vue